







import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import LoginKey from "@/components/login-key";
import imgLogin from "../../../assets/svg/home.svg"
export default createComponent({
  setup() {
    const logo = require('../../../assets/img/logo-jobpay.svg')
    return{
      logo
    }
  },

})
